import { productActionTypes } from 'store/actionTypes';

const initialState = {
  isLoading: false,
  error: null,
  productValidationErrors: [],
  productDraftValidationErrors: [],
  productDraft: null,
  categories: [],
  fixProducts: [],
  flexProducts: [],
  isDraftExists: false,
};

const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case productActionTypes.CREATE_PRODUCT_START:
    case productActionTypes.GET_PRODUCT_DRAFT_START:
    case productActionTypes.UPDATE_PRODUCT_DRAFT_START:
    case productActionTypes.GET_ALL_PRODUCT_CATEGORIES_START:
    case productActionTypes.PUBLISH_PRODUCT_DRAFT_START:
    case productActionTypes.ADD_PRODUCT_DRAFT_ROWS_START:
    case productActionTypes.GET_ALL_FLEX_PRODUCTS_START:
    case productActionTypes.GET_ALL_FIX_PRODUCTS_START:
    case productActionTypes.GET_PRODUCTS_BY_SEARCH_START:
    case productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS_START:
    case productActionTypes.UPDATE_PRODUCT_START:
    case productActionTypes.CHANGE_PRODUCT_START:
    case productActionTypes.CHANGE_PRODUCT_DRAFT_START:
      return {
        ...state,
        isLoading: true,
      };
    case productActionTypes.CHANGE_PRODUCT:
      return {
        ...state,
        isLoading: false,
        error: null,
        productValidationErrors: [],
      };
    case productActionTypes.CHANGE_PRODUCT_DRAFT:
      return {
        ...state,
        isLoading: false,
        error: null,
        productDraftValidationErrors: [],
      };
    case productActionTypes.GET_PRODUCT_DRAFT:
    case productActionTypes.UPDATE_PRODUCT_DRAFT:
    case productActionTypes.ADD_PRODUCT_DRAFT_ROWS:
      return {
        ...state,
        isLoading: false,
        error: null,
        productDraft: payload,
      };
    case productActionTypes.GET_ALL_FLEX_PRODUCTS:
    case productActionTypes.GET_FLEX_PRODUCTS_BY_SEARCH:
      return {
        ...state,
        isLoading: false,
        error: null,
        flexProducts: payload,
      };
    case productActionTypes.GET_ALL_FIX_PRODUCTS:
    case productActionTypes.GET_FIX_PRODUCTS_BY_SEARCH:
      return {
        ...state,
        isLoading: false,
        error: null,
        fixProducts: payload,
      };
    case productActionTypes.UPDATE_FIX_PRODUCT:
      const fixProductsCopy = JSON.parse(JSON.stringify(state.fixProducts));
      const fixIndex = fixProductsCopy.findIndex(
        product => product._id === payload._id,
      );
      fixProductsCopy[fixIndex] = payload;
      return {
        ...state,
        isLoading: false,
        error: null,
        fixProducts: fixProductsCopy,
      };
    case productActionTypes.UPDATE_FLEX_PRODUCT:
      const flexProductsCopy = JSON.parse(JSON.stringify(state.flexProducts));
      const flexIndex = flexProductsCopy.findIndex(
        product => product._id === payload._id,
      );
      flexProductsCopy[flexIndex] = payload;
      return {
        ...state,
        isLoading: false,
        error: null,
        flexProducts: flexProductsCopy,
      };
    case productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isDraftExists: payload,
      };
    case productActionTypes.GET_ALL_PRODUCT_CATEGORIES:
      return {
        ...state,
        isLoading: false,
        error: null,
        categories: payload,
      };
    case productActionTypes.CREATE_PRODUCT:
    case productActionTypes.PUBLISH_PRODUCT_DRAFT:
      return {
        ...state,
        isLoading: false,
        error: null,
        productDraft: [],
      };
    case productActionTypes.CHANGE_PRODUCT_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        productValidationErrors: payload,
      };
    case productActionTypes.CHANGE_PRODUCT_DRAFT_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        productDraftValidationErrors: payload,
      };
    case productActionTypes.CREATE_PRODUCT_ERROR:
    case productActionTypes.GET_PRODUCT_DRAFT_ERROR:
    case productActionTypes.UPDATE_PRODUCT_DRAFT_ERROR:
    case productActionTypes.GET_ALL_PRODUCT_CATEGORIES_ERROR:
    case productActionTypes.PUBLISH_PRODUCT_DRAFT_ERROR:
    case productActionTypes.ADD_PRODUCT_DRAFT_ROWS_ERROR:
    case productActionTypes.GET_ALL_FIX_PRODUCTS_ERROR:
    case productActionTypes.GET_ALL_FLEX_PRODUCTS_ERROR:
    case productActionTypes.GET_PRODUCTS_BY_SEARCH_ERROR:
    case productActionTypes.GET_PRODUCT_IS_DRAFT_EXISTS_ERROR:
    case productActionTypes.UPDATE_PRODUCT_ERROR:
    case productActionTypes.CHANGE_PRODUCT_ERROR:
    case productActionTypes.CHANGE_PRODUCT_DRAFT_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default productReducer;
